import { render, staticRenderFns } from "./View.vue?vue&type=template&id=05c7b5d7&scoped=true&"
import script from "./View.vue?vue&type=script&lang=ts&"
export * from "./View.vue?vue&type=script&lang=ts&"
import style0 from "./View.vue?vue&type=style&index=0&id=05c7b5d7&lang=scss&scoped=true&"
import style1 from "./View.vue?vue&type=style&index=1&lang=scss&module=true&"
import style2 from "./View.vue?vue&type=style&index=2&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "05c7b5d7",
  null
  
)

export default component.exports